





import { Vue, Component } from "@/shared/vuepack";

@Component
export default class UcbFooterInvestment extends Vue {
}
